enum ShopType {
    /**淘宝 */
    TAOBAO = "TAOBAO",

    /**天猫供销平台 */
    TAOBAO_DISTRIBUTION = "TAOBAO_DISTRIBUTION",

    /**京东 */
    JD = "JD",

    /** 京东供销 */
    JD_PURCHASE = "JD_PURCHASE",

    /**阿里巴巴 */
    ALIBABA = "ALIBABA",

    /** 阿里巴巴厂家代发 */
    ALIBABA_SUPPLIER = "ALIBABA_SUPPLIER",

    /**有赞 */
    YOUZAN = "YOUZAN",

    /**微店 */
    WEIDIAN = "WEIDIAN",

    /**美丽说 */
    MEILISHUO = "MEILISHUO",

    /**蘑菇街 */
    MOGUJIE = "MOGUJIE",

    /**苏宁 */
    SUNING = "SUNING",

    /**亚马逊 */
    AMAZON = "AMAZON",

    /**折800 */
    ZHE800 = "ZHE800",

    /**微盟旺铺 */
    WEIMOB = "WEIMOB",

    /**拼多多 */
    PINDUODUO = "PINDUODUO",

    /** 拼多多厂家代发 */
    PDD_FDS = "PDD_FDS",

    /**
     * @deprecated
     * 拼多多跨境
     * 即将下线
     */
    PDD_FULFILLMENT = "PDD_FULFILLMENT",

    /** 快团团 */
    KTT = "KTT",

    /** 快手 */
    KWAI = "KWAI",

    /**卷皮 */
    JUANPI = "JUANPI",

    /**当当 */
    DANGDANG = "DANGDANG",

    /**楚楚街 */
    CHUCHUJIE = "CHUCHUJIE",

    /**楚楚街拼团 */
    CHUCHUJIE_PINTUAN = "CHUCHUJIE_PINTUAN",

    /**返利网 */
    FANLI = "FANLI",

    /**萌店 */
    MENGDIAN = "MENGDIAN",

    /**微盟微商城 */
    WEIMOB_EC = "WEIMOB_EC",

    /**会过 */
    HUIGUO = "HUIGUO",

    /**达令家 */
    DALINGJIA = "DALINGJIA",

    /**环球捕手 */
    GLOBAL_SCANNER = "GLOBAL_SCANNER",

    /**API对接店铺 */
    API_INTEGRATION = "API_INTEGRATION",

    /**手工导入订单 */
    MANUAL = "MANUAL",

    /**楚楚通 */
    CHUCHUTONG = "CHUCHUTONG",

    /**小店 */
    XIAODIAN = "XIAODIAN",

    /**放心购 */
    FANGXINGOU = "FANGXINGOU",

    /**小红书  */
    XIAOHONGSHU = "XIAOHONGSHU",

    /**淘工厂 */
    ALI_C2M = "ALI_C2M",

    /**度小店 */
    DUXIAODIAN = "DUXIAODIAN",

    /** 好衣库(鲸灵) */
    WEBUY = "WEBUY",

    /** 孩子王 */
    HAIZIWANG = "HAIZIWANG",

    /** 爱库存 */
    AIKUCUN = "AIKUCUN",

    /** 爱库存新接口 */
    AIKUCUN_V2 = "AIKUCUN_V2",

    /** 神灯妈妈 */
    SDMM = "SDMM",

    /** 凡科网 */
    FKW = "FKW",

    /** 凡科门店通 */
    FKMDT = "FKMDT",

    /** 华可门店系统 */
    HKMDXT = "HKMDXT",

    /** 唯商城 */
    WSC = "WSC",

    /** 一美大院 */
    YMDY = "YMDY",

    /** 贞德爱心益站 */
    HCTY = "HCTY",

    DOUDIAN = "DOUDIAN",

    /** 抖店代发 */
    DOUDIAN_IOP = "DOUDIAN_IOP",

    /** 抖店供应链（官方） */
    DOUDIAN_SUPPLIER = "DOUDIAN_SUPPLIER",

    /** 快手厂家代发 */
    KWAI_DROPSHIP = "KWAI_DROPSHIP",

    /** 微信小店 */
    CHANNEL_SHOP = "CHANNEL_SHOP",

    /** 微信小店供货商代发 */
    CHANNEL_SHOP_DROPSHIP = "CHANNEL_SHOP_DROPSHIP",

    /** 微信小店供货商供货 */
    CHANNEL_SHOP_SUPPLIER = "CHANNEL_SHOP_SUPPLIER",

    /** 播城(原抖爸爸) */
    DOUBB = "DOUBB",

    /** 自由打印版 */
    INDEPENDENT_MANUAL = "INDEPENDENT_MANUAL",

    // --- 发货易分销系统的供货商类型店铺 --- //
    /**淘宝代发(供货商) */
    TAOBAO_DROP_SHIPPING_SUPPLIER = "TAOBAO_DROP_SHIPPING_SUPPLIER",

    /**拼多多代发(供货商) */
    PDD_DROP_SHIPPING_SUPPLIER = "PDD_DROP_SHIPPING_SUPPLIER",

    /**京东代发(供货商) */
    JD_DROP_SHIPPING_SUPPLIER = "JD_DROP_SHIPPING_SUPPLIER",

    /** 新抖店代发（供货商） */
    DOUDIAN_DROP_SHIPPING_SUPPLIER = "DOUDIAN_DROP_SHIPPING_SUPPLIER",

    /**其他代发(供货商) */
    OTHER_DROP_SHIPPING_SUPPLIER = "OTHER_DROP_SHIPPING_SUPPLIER",
    // --- 发货易分销系统的供货商类型店铺 --- //
}

export default ShopType;
